<div class="uk-section uk-section-default">
  <div class="uk-container uk-container-small">

    <div class="uk-grid uk-child-width-1-3@m uk-child-width-1-3@l uk-child-width-1-1@s">

      <div class="uk-margin-bottom">
        <div>
          <!--fixme I would like to remove the padding from header and list items here-->
          <h6 style="padding: 5px 30px;">Explore</h6>
          <ul class="uk-nav uk-nav-default">
            <li><a [routerLink]="['/explore/open-science-by-area']">Open Science by Area</a></li>
            <li><a [routerLink]="['/explore/open-science-by-country']">Open Science by Country</a></li>
            <li><a [routerLink]="['/explore/open-science-trends']">Open Science Trends</a></li>
            <li><a [routerLink]="['/explore/investments-in-eosc']">Investments in EOSC</a></li>
            <li><a [routerLink]="['/explore/open-science-policies']">Open Science Policies</a></li>
            <li><a [routerLink]="['/explore/open-science-resource-registry']">Open Science Resource Registry</a></li>
          </ul>
        </div>
      </div>

      <div class="uk-margin-bottom">
        <div>
          <!--fixme I would like to remove the padding from header and list items here-->
          <h6 style="padding: 5px 30px;">About</h6>
          <ul class="uk-nav uk-nav-default">
            <li><a [routerLink]="['/about/eosc-observatory']">About EOSC Open Science Observatory</a></li>
            <li><a [routerLink]="['/about/eosc-track']">About EOSC Track</a></li>
            <li><a [routerLink]="['/about/news']">News</a></li>
          </ul>
        </div>
      </div>

      <div>
        <div>
          <!--fixme I would like to remove the padding from header and list items here-->
          <h6 style="padding: 5px 30px;">Resources</h6>
          <ul class="uk-nav uk-nav-default">
            <li><a [routerLink]="['/resources/data-workflow-and-methodology']">Data Workflow and Methodology</a></li>
            <li><a [routerLink]="['/resources/publications-and-deliverables']">Publications</a></li>
            <li><a [routerLink]="['/resources/data-download']">Data download</a></li>
            <li><a [routerLink]="['/resources/support-and-faq']">Support & FAQ</a></li>
            <li><a href="./assets/pdf/EOSC-SB%20Privacy%20Policy%20V3.0.pdf" target="_blank">Privacy Policy</a></li>
          </ul>
        </div>
      </div>

<!--      <div>-->
<!--        <div>-->
<!--          <h6>Social</h6>-->
<!--          <ul class="uk-nav uk-nav-default">-->
<!--            <li><a href="#">Twitter</a></li>-->
<!--            <li><a href="#">LinkedIn</a></li>-->
<!--            <li><a href="#">Zenodo</a></li>-->
<!--            <li><a href="#">Github</a></li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div>-->
<!--          <h6>Legal</h6>-->
<!--          <ul class="uk-nav uk-nav-default">-->
<!--            <li><a href="#">Terms</a></li>-->
<!--            <li><a href="#">Privacy</a></li>-->
<!--            <li><a href="#">Cookies</a></li>-->
<!--            <li><a href="#">Licenses</a></li>-->
<!--            <li><a href="#">Settings</a></li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->

    </div>

  </div>
</div>

<app-footer></app-footer>
